import { render, staticRenderFns } from "./CleanPage.vue?vue&type=template&id=6debd0c0&scoped=true&"
import script from "./CleanPage.vue?vue&type=script&lang=js&"
export * from "./CleanPage.vue?vue&type=script&lang=js&"
import style0 from "./CleanPage.vue?vue&type=style&index=0&id=6debd0c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6debd0c0",
  null
  
)

export default component.exports